import { ThemeProvider } from '@mui/material/styles';
import { MuiProviderProps } from './MuiProvider.types';
import { useMuiConfig } from './useMuiConfig';

export function MuiProvider({ children }: MuiProviderProps) {
  const config = useMuiConfig();

  return <ThemeProvider theme={config}>{children}</ThemeProvider>;
}
